import { isMobile } from './is-mobile'
import 'waypoints/lib/jquery.waypoints.min.js'

/*
 *
 * ----------------------------------------------- */
// jQuery(window).on('load', function () {
//   if (isMobile()) {
//     $('body').addClass('active')
//     $('.animation').addClass('active')
//   }
// })

jQuery(function ($) {
  $('.animation').waypoint({
    handler: function (direction) {
      $(this.element).addClass('active')

      this.destroy()
    },
    offset: '80%'
  })

  $('.p-home__blog-section').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('body').addClass('active')
      }, 1800)

      this.destroy()
    },
    offset: '100%'
  })

  $('#p-culture__office').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('body').addClass('active')
      }, 1800)

      this.destroy()
    },
    offset: '100%'
  })

  $('.section-conversation').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('body').addClass('active')
      }, 1700)

      this.destroy()
    },
    offset: '100%'
  })

  $('#oneday-slider').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('.oneday-white-layer').addClass('active')
      }, 1800)

      this.destroy()
    },
    offset: '100%'
  })

  $('.section-career-orange').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('body').addClass('active')
      }, 1700)

      this.destroy()
    },
    offset: '100%'
  })

  $('.setion-career-button').waypoint({
    handler: function (direction) {
      setTimeout(() => {
        $('body').addClass('active')
      }, 1700)

      this.destroy()
    },
    offset: '100%'
  })
})

$(document).ready(function () {
  if ($('body').hasClass('culture')) {
    $('body.culture img[loading="lazy"]').removeAttr('loading')
  }
})
